const normalizeLocale = (locale?: string | null) =>
    locale?.trim().replace("_", "-").toLowerCase();

export const resolveApplicationLocale = (
    savedLocale?: string | null,
    browserLocales: readonly string[] = [],
    supportedApplicationLocales: readonly string[] = []
): string => {
    const candidates = [savedLocale, ...browserLocales].filter(
        (candidate): candidate is string => Boolean(candidate?.trim())
    );

    for (const candidate of candidates) {
        const normalized = normalizeLocale(candidate);
        const exact = supportedApplicationLocales.find(
            (supported) => normalizeLocale(supported) === normalized
        );
        if (exact) {
            return exact;
        }
    }

    for (const candidate of candidates) {
        const language = normalizeLocale(candidate)?.split("-")[0];
        const familyMatch = supportedApplicationLocales.find(
            (supported) =>
                normalizeLocale(supported)?.split("-")[0] === language
        );
        if (familyMatch) {
            return familyMatch;
        }
    }

    return (
        supportedApplicationLocales.find(
            (locale) => normalizeLocale(locale) === "en-us"
        ) ??
        supportedApplicationLocales[0] ??
        "en-US"
    );
};

export const getBrowserLocales = (): string[] => {
    if (typeof navigator === "undefined") {
        return [];
    }
    return navigator.languages?.length
        ? [...navigator.languages]
        : navigator.language
          ? [navigator.language]
          : [];
};
